import React from "react";
import { useTheme, CircularProgress, Stack } from "@mui/material";
import Tooltip from "@hyro-components/Tooltip";
import { LAYOUTS, TYPES } from "src/components/widgets/FieldCopyPaste/CopyPaste.consts";
import { StyledIconButton } from "src/components/widgets/FieldCopyPaste/CopyPaste.commons";
import TriggerPlayIcon from "src/icons/player/TriggerPlayIcon";
import TriggerPauseIcon from "src/icons/player/TriggerPauseIcon";

const PlayPauseButton = ({ onClick, isPlaying, isLoading, disabled = false, testId }) => {
  const theme = useTheme();

  return (
    <Tooltip
      disableInteractive
      title={isLoading ? "Loading..." : isPlaying ? "Pause utterance" : "Play utterance"}
    >
      <StyledIconButton
        onClick={onClick}
        disabled={disabled}
        size={26}
        type={TYPES.FLAT}
        layout={LAYOUTS.ROUNDED}
        sx={{ backgroundColor: isPlaying ? theme.palette.tertiary[300] : theme.palette.system[0] }}
        data-testid={testId}
      >
        {isLoading ? (
          <Stack alignItems="center" justifyContent="center" width={26} height={26}>
            <CircularProgress size={16} sx={{ color: theme.palette.system[700] }} />
          </Stack>
        ) : isPlaying ? (
          <TriggerPauseIcon size={18} style={{ flexShrink: 0, width: "18px", height: "18px" }} />
        ) : (
          <TriggerPlayIcon size={18} style={{ flexShrink: 0, width: "18px", height: "18px" }} />
        )}
      </StyledIconButton>
    </Tooltip>
  );
};

export default PlayPauseButton;
